import e from "react";
const t = e.createContext({
  code: null
});
function n() {
  return e.useContext(t);
}
export {
  t as L,
  n as u
};
